<template>
  <div>
  <modal
        v-if="outputModal"
        ref="modal"
        id="agOutputModal"
        v-model="showOutputModal"
        styles="display:flex; flex-direction:column; padding:15px;"
        name="outputModal"
        content-class="modal-content"
        :draggable=true
        :adaptive=true
        :resizable=true
        :fit-parent="true"
        :clickToClose="false"
        :key="reload"
        :shiftX=.5
        :shiftY=0
        width="1125px"
        height="85%"
        drag="drag"
        :resize-directions="['r', 'l', 'tl', 'tr', 'bl', 'br']"      
        @keyup.enter.native="saveButton_click">
      <div>
      <h4 v-if="disableUI" class="agModal-title">View Output</h4>
      <h4 v-else class="agModal-title">Edit Output</h4>
      <hr/>
    </div>
    <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
    <div class="agInputGroup agInputGroupCentered">
      <label>Source:</label>
      <b-input type="text" v-model="srcStr" autocomplete="false" disabled></b-input>
    </div>
    <b-input-group size="md" style="padding:14px;" prepend="Name">
      <b-input type="text" v-model="output.name" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <b-input-group size="md" style="padding:14px;" prepend="Description">
      <b-input type="text" v-model="output.description" autocomplete="false" :disabled="disableUI"></b-input>
    </b-input-group>
    <hr />
    <ag-fields-selector
      ref="fieldsSelector"
      :node="output"
      :disableUI="disableUI"
      :connections="connections"
      :hasChildObjects="true"
      @refreshedSchemas="refreshedSchemas"
      @connectionChanged="connectionChanged"
      @layerChanged="layerChanged">
    </ag-fields-selector>
    <div v-if="showGeometry" class="agInputGroup agInputGroupCentered">
      <input type="checkbox" v-model="output.includeGeometry" :disabled="disableUI" />
      <label>Include geometry</label>
    </div>
    <div class="agInputGroup agInputGroupCentered">
      <label>Action:</label>
      <b-form-select
        class="agSmallInput"
        v-model="output.action"
        :options="actions"
        :disabled="disableUI || actions.length == 0"
      ></b-form-select>
    </div>
    <hr />
    <div style="display:flex;">
      <div class="agInputGroup agInputGroupCentered">
        <label>Result Destination:</label>
        <b-input type="text" v-model="dest.shortname" autocomplete="false" disabled></b-input>
      </div>
      <div class="agInputGroup agInputGroupCentered" style="margin-left:11rem; margind-top:-10px;">
        <b-form-checkbox id="dest3" name="checkbox-1" :checked="dest3.selected" @change="changeDest('dest3')" style="margind-top:4%" value=true unchecked-value=false>
        </b-form-checkbox>
        <label>Error Destination:</label>
        <b-input type="text" :value="dest3.shortname" autocomplete="false" disabled></b-input>
      </div>
    </div>
    <div v-if="modalMessage">
      <hr />
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    </div>
    <div>
      <hr/>
      <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button
        class="agModal-buttonRight"
        variant="danger"
        :disabled="disableUI || isLoading"
        @click="deleteButton_click"
        style="margin-left:82%;"
      >Delete</b-button>
      <b-button
        class="agModal-buttonRight"
        variant="primary"
        :disabled="disableUI || isLoading"
        @click="saveButton_click"
        style="float:right;"
      >Save</b-button>
    </div>

    <!-- delete modal -->
    <b-modal
        class="agModal"
        ref="deleteModal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @keyup.enter.native="deleteButton_click"
      >
        <template slot="modal-header">
          <h4 class="agModal-title danger">Delete Output</h4>
        </template>
        Are you sure you want to delete output
        <i>{{ name }}</i
        >?
        <template slot="modal-footer" slot-scope="{ cancel }">
          <b-button class="agModal-buttonLeft" @click="cancel"
            >Cancel</b-button
          >
          <b-button
            class="agModal-buttonRight"
            variant="danger"
            @click="confirmDeleteButton_click"
            >Delete</b-button
          >
        </template>
      </b-modal>
  </modal>  
  </div>
</template>


<script>

// components
import FieldsSelector from "comp/ui/FieldsSelector"

// modules
import Server from "src/server";
import Util from "src/util/util";
import _ from 'lodash';

export default {
  name: "ag-output-modal",
  components: {
    "ag-fields-selector": FieldsSelector
  },
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean,
  },
  data() {
    return {
      showOutputModal:false,
      reload:0,
      output: null,
      outputModal: false,
      isLoading: false,
      reloadFields: 0,
      modalMessage: "",
      modalMessageClass: "",
      children: [],
      showGeometry: false,
      actions: [],
      dest: {shortname: null},
      dest3: {shortname: null, selected: false}
    };
  },
  computed: {
    /*
    output() {
      if (this.node && this.node.type == "output") {
        var fields = this.node.object.connection.schemas[0].fields;
        console.log("computed - " + JSON.stringify(fields[fields.length - 1]));
        return this.node.object;
      }
      return null;
    },
    */

    name() {
      if (this.output.name) {
        return this.output.name;
      }
      return this.output.shortname;
    },

    srcStr() {
      if (!this.output.src || this.output.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.output.src.length; i++) {
        var src = this.output.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    connections() {
      var inputOutputConnections = this.$store.state.connStore.connections;
      const csv_find = inputOutputConnections.find(csvs => csvs.type === "csv")
        const csv_connection = {
          name:"CSV File",
          type:"csv",
         _id:"65a0df0edd0c00df00ccf000"
        }
        if(!csv_find){
          inputOutputConnections.push(csv_connection)
        }
      if(this.output.connection){
        let newConn = inputOutputConnections.find(c => c._id == this.output.connection._id)
        this.output.connection = newConn;
      }
      console.log(inputOutputConnections)
      return inputOutputConnections.filter(c => c.type != "geometry").map(b => {return {value: b, text: b.name};});
    },

    layerLabel() {
      if (this.output.connection && this.output.connection.type == "max") {
        return "Object:";
      }
      return "Layer:";
    },

    filteredFields() {
      if (!this.fieldSearchText) return this.fields;

      var filteredFields = this.fields.filter(
        (a) =>
          (a.field &&
            a.field.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) >
              -1) ||
          (a.alias &&
            a.alias.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) >
              -1)
      );
      return filteredFields;
    },

    nextChild() {
      var num = 0;
      for (var i = 0; i < this.output.childObjects.length; i++) {
        var child = this.output.childObjects[i];
        var childNum = parseInt(child.shortname.replace("C-", ""));
        if (num <= childNum) {
          num = childNum;
        }
      }
      return num + 1;
    },
  },
/*
  watch: {
    node: {
        handler(newValue) {
          if (this.node && this.node.type == "output") {
            var fields = this.node.object.connection.schemas[0].fields;
            console.log("watch - " + JSON.stringify(fields[fields.length - 1]));
            this.output = this.node.object;
            //this.$refs["fieldsSelector"].output = this.output;
            return;
          }
          this.output = null;
        }, deep: true
      }
  },
  */

  methods: {
    // UI Events

    changeDest(dest){
      if (dest == "dest3"){
        if(this.dest3.selected){
          this.dest3 = {shortname: null, selected: false}
        }else {
          this.dest3.selected = !this.dest3.selected
        }
      }
    },
    init(){
      //init destObject with the prop data
      if(this.node.object.dest !== undefined){
        this.dest = this.node.object.dest;
      }
      else {
        this.dest = {shortname: null}
      }
      if(this.node.object.dest3 !== undefined){
        this.dest3 = this.node.object.dest3;
      }
      else {
        this.dest3 = {shortname: null, selected: false}
      }
    },
    cancelButton_click() {
      this.$modal.hide('outputModal');
      this.outputModal = false;
    },
    async saveButton_click() {
      this.modalMessage = "";

      // remove the last empty, placeholder child object
      this.output.childObjects.pop();

      // empty fields and child object fields
      this.output.fields = [];
      for (var i = 0; i < this.output.childObjects.length; i++) {
        var child = this.output.childObjects[i];
        child.fields = [];
      }

      this.output.dest = this.dest;
      this.output.dest3 = this.dest3;

      // repopulate fields
      for (var i = 0; i < this.$refs.fieldsSelector.fields.length; i++) {
        var field = this.$refs.fieldsSelector.fields[i];
        console.log("field ",field);
        if (field.enabled) {
          if (field.child) {
            var child = this.output.childObjects.find(
              (a) => a.shortname == field.child
            );
            var prefix = child.shortname + ": ";
            var fieldName = field.field;
            fieldName = fieldName.substring(prefix.length, fieldName.length);
            child.fields.push(fieldName);
          } else {
            var fieldName = field.field;
            this.output.fields.push(fieldName);
          }
        }
      }

      var node = {
        object: this.output,
        type: "output",
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node,
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "output",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.output,
        type: "output",
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node,
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

   
    // emitted events 

    refreshedSchemas() {
      var fields = this.output.fields;
      console.log(`output's refreshedSchemas - ${JSON.stringify(fields[fields.length-1])}`);
      this.setActions();
      this.$emit("reloadNodes");
    },

    connectionChanged() {
      console.log("on conn change ",this.output.connection);
      if(this.output.connection && (this.output.connection.type == "esri" || this.output.connection.type == "agol"))
        this.showGeometry = true;
      else
        this.showGeometry = false;

      this.setActions();
    },

    layerChanged() {
      this.setActions();
    },

    // other
    show() {
      this.outputModal = true;
      this.setOutput();
           
      setTimeout(() => {
        this.reset();
        this.$modal.show('outputModal',{ draggable: true });
      }, 100);
    },

    hide() {
      this.$modal.hide('outputModal');
    },

    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      if (this.output.connection && (this.output.connection.type == "esri" || this.output.connection.type == "agol"))
        this.showGeometry = true;
      else 
        this.showGeometry = false;

      this.init()
      // add an empty child object as a placeholder
      if (
        this.output.childObjects.length == 0 ||
        this.output.childObjects[this.output.childObjects.length - 1].name != ""
      ) {
        this.output.childObjects.push({
          name: "",
          shortname: "C-" + this.nextChild,
          fields: [],
        });
      }

      this.setActions();
      var self = this;
      setTimeout(() => {
        self.$refs.fieldsSelector.reset();
      }, 100);
    },

    setOutput() {
      if(this.node && this.node.type == "output") 
        this.output = this.workflow.outputs.find((object) => object._id == this.node.object._id);
      else
        this.output = null;
    },

    setActions() {
      this.actions = [];
      var schema  = ""
      // this.output.layer = "File"
      if (this.output.connection && this.output.layer) {
        if(this.output.connection.type === "csv"){
          // const schemat =[{
          //   actions:[
          //     "Save To File"
          //   ],
          //   fields:[
          //     {
          //       alias:"CSV",
          //       defaultValue:null,
          //       name:"Save To File",
          //       nullable:false,
          //       type:"STRING"
          //     }
          //   ],
          //   id:"File",
          //   name:"File"
          // }]
          // this.output.connection.schemas.push(schemat[0])
          schema = this.output.connection.schemas.find(schema =>schema.id == this.output.layer)
          console.log("schema ",schema);
        }else{
          schema = this.output.connection.schemas.find(schema => schema.id == this.output.layer);
        }        
        console.log("SCHEMAFD ",schema)
        if(schema){
            this.actions = schema.actions;
            console.log("sec ",schema.actions);
          } 
        }
      },
  } 
};
</script>


<style scoped lang="css">
#agOutputModal-childObjects {
  position: relative;
  left: 476px;
}

.agOutputModal-childObject {
  margin-left: 50px;
}

.agOutputModal-childObject label {
  text-align: right;
}

.agOutputModal-deleteChildObjectButton {
  position: absolute;
  margin-left: 10px;
  margin-top: 5px;
  font-size: 20px;
}

#agOutputModal-fieldsTable {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 155px);
  height: 175px;
  margin: 5px 0px 0px 100px;
  overflow: auto;
  border-collapse: collapse;
}

#agOutputModal-fieldsTableSpinner {
  position: relative;
  left: -500px;
  top: 75px;
}

#agOutputModal-fieldSearch {
  width: calc(100% - 200px);
}
</style>

<style lang="css">

#agOutputModal-fieldsTable .agOutputModal-fieldsTableCell {
  min-width: 125px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/nodes/OutputModal.vue